import bitcoin from '@exodus/bitcoin-plugin'
import ethereum from '@exodus/ethereum-plugin'
import solana from '@exodus/solana-plugin'

const assetPlugins = {
  bitcoin,
  ethereum,
  solana,
}

export default assetPlugins
